<template>
  <div>
    <Nav />
    <div class="content-wrap" v-if="IsTmRZ">
      <div style="padding:20px 0 30px 0;">
        <el-button v-if='IsPrintedPage' :style="btnAllStyle" type="primary" class="down-btn" @click="getVisitor" :loading="showBtnLoading">下载确认函</el-button>
      </div>
      <iframe class="iframe" :src="infoSrc"></iframe>
    </div>
    <div class="content-wrap" v-else>
      <div style="padding:20px 0 30px 0;text-align: center;">
        Please scan the QR code below to upload your profile picture and ID photo.<br /><br />
        <img :src="TMCode" style="width: 20%;">
      </div>
    </div>
    <div class="meetingMain" v-if="IsRegistActivity">
      <h3 class="title">已报名会议</h3>
      <div class="meetList" v-if="payMeeting&&payMeeting.length>0">
        <el-table
          :data="payMeeting"
          style="width: 100%">
          <el-table-column
            prop="AtyTheme"
            label="名称"
            width="180">
          </el-table-column>
          <el-table-column
            label="时间"
            width="240">
            <template slot-scope="scope">{{scope.row.AtyDate+ ' ' +scope.row.AtyBTime + '-' + scope.row.AtyETime}}</template>
          </el-table-column>
          <el-table-column
            prop="AtyPlace"
            label="地点">
          </el-table-column>
          <el-table-column
            prop="AtyContent"
            label="详情">
          </el-table-column>
        </el-table>
      </div>
      <div style="text-align:center; padding:20px 0;" v-else>
        <div style="padding:10px 0 20px 0">您还没有报名会议</div>
        <el-button class="bmBtn" @click="toMeeting" :style="btnAllStyle">报名会议</el-button>
      </div>
    </div>
    <div class="extendInfo" v-html="ExtendInfo"></div>
    <div class="adImg"><img :src="FooterAdImage" alt=""></div>
    <!-- 参观日期 -->
    <div class="visiteDatebox">
      <div>You have scheduled a date：</div>
      <div class="dates">
        <div class="dateItem" v-for="item in chooseDate" :key="item.VID">
          <div class="dItemDate">{{item.VisEDate}} </div>
          <div class="dItemBtn" @click="DeleteVisDate(item)" v-if="item.IsCancel == '1' && chooseDate.length > 1">Cancel</div>
        </div>
      </div>
      <el-button round @click="addTime()" class="addBtn">Add appointment date</el-button>
    </div>
    <!-- 参观日期 -->
    <el-dialog title="Visit appointment date"
      :visible.sync="changeTimeVisible"
      width="50%"
      top="30vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :center="false">
      <div style="text-align:center;padding:10px 10px" class="radioBox">
        <el-checkbox-group v-model="chooseDateIDs" class="dateChecks" fill="#E63468">
          <el-checkbox-button v-for="(item,index) in Datelist" :disabled="item.disabledVal || item.IsEnable == '0'" :label="item.SetID" :key="index">
            <span style="display: block; margin-bottom: 5px;">{{ item.SetKey }}</span>
            <span>{{ item.SetValue }}</span>
          </el-checkbox-button>
        </el-checkbox-group>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button size="mini" @click="changeTimeVisible = false">Cancel</el-button>
        <el-button size="mini" type="primary" @click="changeTime()" style="background:#E63468;border:1px solid #E63468" :loading="cfmLoading">OK</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from '../api'
import Nav from '../components/Nav'
import utils from '../utils'
import TMCode from '../../static/img/TMCode.png'
export default {
  name: 'Confirmation',
  components: {
    Nav
  },
  data() {
    return {
      successHtml: '',
      infoSrc: '',
      ExhID: sessionStorage.getItem('ExhID'),
      IsPrintedPage: false,
      showBtnLoading: false,
      ExtendInfo: '',
      FooterAdImage: '',
      btnAllStyle: sessionStorage.getItem('btnAll') ? JSON.parse(sessionStorage.getItem('btnAll')).styles : {},
      payMeeting: [],
      IsRegistActivity: sessionStorage.getItem('IsRegistActivity') ? JSON.parse(sessionStorage.getItem('IsRegistActivity')) : true,
      PsnTrade: '',
      TMCode: TMCode,
      changeTimeVisible: false,
      currnetData: sessionStorage.getItem('currentTime'),
      chooseDate: [],
      chooseDateIDs: [],
      bgStyle: '#333',
      currentDay: {
        '1143': '#006c33',
        '1144': '#0000FF',
        '1145': '#FF8000'
      },
      Datelist: [], // 参观日期选项
      cfmLoading: false,
      registInfo: [],
      IsTmRZ: false
    }
  },
  mounted() {
    if (this.ExhID) {
      this.getUserInfo()
      this.getConfigInfo()
      this.getRegistInfo()
      this.checkIdFace()
      this.getDates()
      if (this.IsRegistActivity) {
        this.getPersonAty()
      }
    }
    utils.setThemeColor()
  },
  methods: {
    checkIdFace() {
      console.log(this.registInfo, 111)
      api.checkIdFace({exhibitionId: '1739479926908952577', cardNo: this.registInfo.PsnCardNo})
        .then(res => {
          console.log(res)
          if (res.data.code === 200) {
            if (res.data.msg === '已认证') {
              this.IsTmRZ = true
            } else if (res.data.msg === '未认证') {
              this.IsTmRZ = false
            }
          }else{
            // setTimeout(() => {
            //   this.checkIdFace()
            // }, 1000)
          }
        }).catch(() => {
          this.loading = false
        })
    },
    changeTime() {
      if (this.chooseDateIDs.length <= 0) {
        this.$alert('Please select a date！', 'Tips')
        // this.$notify({
        //     title: "提示信息",
        //     message: '请选择日期！',
        //     type: 'error'
        //   });
        return false
      }
      this.cfmLoading = true
      api.SaveVisDateTime({
        PsjID: sessionStorage.getItem('PsjID'),
        ExhID: sessionStorage.getItem('ExhID'),
        VID: '',
        STimeID: '',
        SDateID: this.chooseDateIDs.join(',')
      }).then(res => {
        if (res.data.status === 'OK') {
          this.GetVisiteDateHandler()
          this.$alert('Successfully added！', 'Tips')
          this.changeTimeVisible = false
        }else{
          this.$alert(res.data.ErrorEMsg, 'Tips')
          this.cfmLoading = false
        }
      })
    },
    DeleteVisDate(item) {
      api.DeleteVisDate({
        PsjID: sessionStorage.getItem('PsjID'),
        ExhID: sessionStorage.getItem('ExhID'),
        VID: item.VID
      }).then(res => {
        if (res.data.status === 'OK') {
          this.GetVisiteDateHandler()
        } else {
          this.$alert(res.data.ErrorEMsg, 'Tips')
        }
      })
    },
    addTime() {
      this.chooseDateIDs = []
      this.Datelist = this.Datelist.map(val => {
        val.disabledVal = false
        return val
      })
      for (var i = 0; i < this.chooseDate.length; i++) {
        this.Datelist = this.Datelist.map(val => {
          if (val.SetID == this.chooseDate[i].ParentID) {
            val.disabledVal = true
          }
          return val
        })
      }
      this.cfmLoading = false
      this.changeTimeVisible = true
    },
    async GetVisiteDateHandler () {
      console.log(11111)
      const res = await api.GetVisiteDateByPsjID({
        ExhID: this.ExhID,
        PsjID: sessionStorage.getItem('PsjID')
      })
      if (res.data.status === 'OK') {
        this.chooseDate = res.data.Data
        // var _data = new Date(this.currnetData.replace(/-/g, '/'))
        // // 获取当前日期（日）
        // var day = _data.getDate()
        // // 是否已约当天日期
        // var _isHasDay = false
        // var hasToday = this.chooseDate.find(item => {
        //   return item.VisDate.indexOf(day) > -1
        // })
        // if (hasToday) {
        //   _isHasDay = true
        // }
        // if (_isHasDay) {
        //   // 如果选了当前日期
        //   this.bgStyle = this.currentDay[hasToday.ParentID]
        // }else{
        //   // 如果没选当前日期
        //   this.bgStyle = '#333'
        // }
        // this.drawQr()
      } else {
        this.$alert(res.data.ErrorEMsg, 'Tips')
      }
    },
    getDates() {
      if (sessionStorage.getItem('ExhID')) {
        api.GetDatalist({ExhID: sessionStorage.getItem('ExhID')}).then(res => {
          if (res.data.status === 'OK') {
            this.Datelist = res.data.Data
          } else {
            this.$alert(res.data.ErrorEMsg, 'Tips')
          }
        });
      }
    },
    getRegistInfo() {
      api.getRegistInfo({
          ExhID: this.ExhID,
          PsjID: sessionStorage.getItem('PsjID')
        })
        .then(res => {
          if (res.data.status === 'OK') {
            this.registInfo = res.data.Data
            this.PsnTrade = res.data.PsnTrade
            console.log(this.registInfo, 222)
            this.checkIdFace()
          }
        })
    },
    getPersonAty () {
      api.getPersonAty({
        ExhID: this.ExhID,
        PsjID: sessionStorage.getItem('PsjID')
      }).then(res => {
        if (res.data.status === 'OK') {
          res.data.data.map(item => {
            item.AtyDate = item.AtyDate.split(' ')[0]
          })
          this.payMeeting = res.data.data
        } else {
          this.$alert(res.data.ErrorEMsg, 'Tips')
        }
      })
    },
    toMeeting() {
      this.$router.push({path: '/meeting', query: {ExhID: sessionStorage.getItem('ExhID')}});
    },
    getVisitor () {
      var _this = this
      _this.showBtnLoading = true
      var param = {
        exhid: this.ExhID,
        psjid: sessionStorage.getItem('PsjID')
      };
      api.getConfirmPdf(param).then(res => {
        _this.showBtnLoading = false
        if(res.data.status == 'OK') {
          var url = res.data.pdfUrl
          url = url.replace('http:', 'https:')
          window.open(url);
        }else{
          _this.$alert(res.data.ErrorEMsg, 'Tips')
        }
      })
    },
    getUserInfo () {
      var successInfo = {
        exhid: this.ExhID,
        EntryPsjId: sessionStorage.getItem('PsjID')
      }
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      api.visitorStrategy(successInfo).then(
        res => {
          loading.close()
          if (res.data.status === 'OK') {
            this.infoSrc = res.data.HtmlInfo
            this.$store.commit('setVisitorID', res.data.PsnID)
            // sessionStorage.setItem('PsnID', res.data.PsnID)
            sessionStorage.setItem('PsnID', res.data.EntryPsnID)
            sessionStorage.setItem('noJmPsnID', res.data.PsnID)
            sessionStorage.setItem('PsnName', res.data.PsnName)
            this.GetVisiteDateHandler()
          } else {
            this.$alert(res.data.ErrorEMsg, 'Tips')
          }
        },
        error => {
          loading.close()
          console.log(error)
        }
      )
    },
    getConfigInfo() {
      var That = this
      var param = {
        ExhID: this.ExhID,
        RegistType: 'pc',
        page: 'successpage'
      }
      api.getPage(param).then(res => {
        if(res.data.status === 'OK') {
          res.data.promptinfo.forEach(ele => {
            if(ele.name === 'PageTips') {
              That.successHtml = ele.value
            }
            if(ele.name === 'ExtendInfo') {
              That.ExtendInfo = ele.value
            }
          })
          res.data.switchInfos.forEach(ele => {
            if(ele.name === 'IsPrintedPage') {
              That.IsPrintedPage = ele.data
            }
          })
          res.data.images.map(item => {
            if (item.name === 'FooterAdImage') {
              That.FooterAdImage = item.data[0]
            }
          })
        }else{
          That.$alert(res.data.ErrorEMsg)
        }
      })
    }
  }
}
</script>
<style lang="scss">
.content-wrap{
  background: #fff;
  text-align: center;
  padding-top:30px;
}
.iframe {
  width: 80%;
  max-width: 720px;
  min-height: 700px;
  background: #fff;
  border: none;
  display: inline-block;
}
.adImg img{
  width: 100%;
  margin-top: 20px;
}
.meetingMain{
  padding: 10px 20px;
  box-shadow: 1px 1px 12px #dedede;
  margin-top: 20px;
  background: #fff;
  .title{
    font-weight: normal;
    padding: 30px 0;
    border-bottom: 1px solid #dedede;
  }
  .meetList{
    padding: 45px 0;
  }
  .bmBtn.el-button{
    width: 20% !important;
    position: static !important;
    color: #FFF;
    background-color: #409EFF;
    border-color: #409EFF;
    margin: 0 30px;
  }
}
.visiteDatebox{
  padding:0.1rem 0.2rem 0;
  text-align: center;
  // color:#fff;
  .addBtn{
    // background: transparent !important;
    // color: #fff !important;
  }
  .dates{
    display:flex;
    flex-wrap: wrap;
    padding: 0 0 0.5rem 0;
    width: 30%;
    margin: 0 auto;
    .dateItem{
      display:flex;
      padding-top:0.24rem;
      align-items: center;
      width:50%;
      .dItemDate{
        font-size:0.8rem;
        font-weight:bold;
      }
      .dItemBtn{
        // background:linear-gradient(90deg, #E14544, #a6f5fd);
        background: #E63468;
        border:1px solid #fff;
        color:#fff;
        padding:0.1rem 0.2rem;
        margin-left:0.3rem;
        border-radius:0.12rem;
        font-size:0.6rem;
        box-shadow:rgb(255, 255, 255) 0px 0px 15px;
        cursor: pointer;
      }
    }
  }
}
.radioBox{
  .dateChecks{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .el-checkbox-button__inner{
      padding:0.24rem 0.26rem;
      border: 0.026667rem solid #dcdfe6;
    }
    .el-checkbox-button.is-disabled{
      .el-checkbox-button__inner{
        background-color: #eee !important;
        border-color: #ccc !important;
      }
    }
  }
  .el-radio{
    background:#efefef !important;
    border-radius:6px !important;
    padding:10px !important;
    span{
      display:block;
      padding:4px 0;
    }
    .el-radio__input{
      display:none !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Confirmation.vue